import React from 'react'
import { useHistory } from 'react-router-dom'
import { Button, Card, Result } from 'antd'

const SuccessCom = () => {
  const history = useHistory()

  return (
    <>
      <div className='card-container'>
        <Card className="retrieve-form-card">
          <Result
            status='success'
            title="重置密码成功！"
            className='setPwdResult'
            extra={
              <Button type="primary" size="large" onClick={() => history.push('/login')} className='goLoginButton'>
                去登录
            </Button>
            }
          />
        </Card>
      </div>
    </>
  )
}

export default SuccessCom
